import { render, staticRenderFns } from "./MeinBigtex.vue?vue&type=template&id=4bcfd436&"
import script from "./MeinBigtex.vue?vue&type=script&lang=js&"
export * from "./MeinBigtex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bcfd436')) {
      api.createRecord('4bcfd436', component.options)
    } else {
      api.reload('4bcfd436', component.options)
    }
    module.hot.accept("./MeinBigtex.vue?vue&type=template&id=4bcfd436&", function () {
      api.rerender('4bcfd436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/MeinBigtex.vue"
export default component.exports